<template>
    <div class="wlx-meeting-manager-wrapper">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">会议活动</span>
            </div>
            <div class="fr btn-right">
                <el-form :inline="true" size="small">
                    <el-form-item >
                        <el-input v-model="sTitle" placeholder="请输标题" clearable></el-input>
                    </el-form-item>
                    <el-form-item >
                        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    </el-form-item>
                    <el-form-item >
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
                    </el-form-item>
                    <el-form-item >
                        <el-button type="primary" @click="sort">排序</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="yk-wrap-fixed">
            <div class>
                <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark" empty-text=" ">
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column prop="title" label="会议标题" width :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="会议类型" width>
                        <template slot-scope="scope">
                            <!-- <span v-if="scope.row.meetingType == 0">1+X培训</span> -->
                            <span v-if="scope.row.meetingType == 1">师资培训</span>
                            <span v-else-if="scope.row.meetingType == 2">专业研讨</span>
                            <span v-else-if="scope.row.meetingType == 3">高层论坛</span>
                            <span v-else>其它</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="会议状态" width>
                        <template slot-scope="scope">
                            <span v-if="scope.row.state == 0">未开始</span>
                            <span v-else-if="scope.row.state == 1">进行中</span>
                            <span v-else-if="scope.row.state == 2">已结束</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否展示" width>
                        <template slot-scope="scope">
                            <span v-if="scope.row.isShow == 0">否</span>
                            <span v-else>是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dateCreated" label="创建时间" width></el-table-column>
                    <el-table-column prop="startTime" label="开始时间" width></el-table-column>
                    <el-table-column prop="endTime" label="结束时间" width></el-table-column>
                    <el-table-column prop="SchoolCount" label="报名单位数" width></el-table-column>
                    <el-table-column prop="PersonCount" label="报名总人数" width></el-table-column>
                    <el-table-column label="操作" width="300">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                <el-button size="mini" class="el-icon-edit" @click="edit(scope.row)" type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="报名详情" placement="top-start">
                                <el-button size="mini" class="el-icon-view" @click="gOView(scope.row.id)" type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="设置酒店" placement="top-start">
                                <el-button size="mini" class="wl-icon-jiudian" @click="gOHotel(scope.row.id)" type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                <el-button size="mini" type="danger" class="el-icon-delete" @click="deleteMajor(scope.row.id)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    class="wl-pagination-text"
                    @size-change="handleSizeChange"
                    @current-change="onPageChangeHandler"
                    :current-page="pageIndex"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    v-show="total > 0"
                ></el-pagination>
            </div>
        </div>

        <el-dialog title="会议活动排序" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" class="dialog-course-sortable" :visible.sync="dialogVisible" width="60%" top="1%">
            <sortable-list lockAxis="y" v-model="list" helperClass="sortable-fixed-sortitem sortable-fixed-sortitem-course" style="overflow: auto;height: 100%;" class="clearfix" @input="onInput">
                <sortable-item v-for="(item, index) in list" :index="index" :key="index" :item="item">
                    <div>
                        {{ item.title }}
                        <img v-handle src="~assets/images/yidong.png" style="width:21px;height:21px;float:right;margin:8px;cursor: pointer;" />
                    </div>
                </sortable-item>
            </sortable-list>
        </el-dialog>

        <div v-if="noDataShow" class="yk-nodata-source-content">
            <img src="~assets/images/the-last-new-nodata-imag.png" alt class="yk-prompt" />
            <!-- <div class="sp-noData" style="color:#000">暂无数据。</div> -->
        </div>

        <!-- 新增会议 -->
        <el-dialog title="新增会议" :visible.sync="addNewNoticeVisible" @close="cancel('ruleForm')" :append-to-body="true" width="70%" :close-on-click-modal="false">
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" v-if="addNewNoticeVisible">
                    <el-form-item label="会议标题" prop="title">
                        <el-input v-model="ruleForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="会议内容">
                        <Editor v-model="ruleForm.content" placeholder="请输入内容" />
                    </el-form-item>
                    <el-form-item label="会议说明">
                        <Editor v-model="ruleForm.Explain" placeholder="请输入会议" />
                    </el-form-item>
                    <el-form-item label="会议类型" prop="meetingType">
                        <el-select placeholder="请选择会议类型" size="small" v-model="ruleForm.meetingType">
                            <el-option v-for="item in selects" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会议地点" prop="address">
                        <el-input v-model="ruleForm.address"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="会议费用" prop="fee" style="width: 30%">
                        <el-input type="number" v-model="ruleForm.fee"></el-input>
                        <span style="color: red;">（单个人费用/元）</span>
                    </el-form-item> -->
                    <el-form-item label="是否展示" prop="isShow">
                        <el-radio-group v-model="ruleForm.isShow">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contact">
                        <el-input v-model="ruleForm.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式" prop="phone">
                        <el-input v-model="ruleForm.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="会议封面">
                        <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image" v-if="addNewNoticeVisible"></imageUpload>
                    </el-form-item>
                    <el-form-item label="会议材料">
                        <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUpload" class="apply-file-upload fl"></applyFileUpload>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="StartTime">
                        <el-date-picker v-model="ruleForm.StartTime" value-format="yyyy-MM-dd" type="date" @change="getMeetTime" placeholder="选择开始时间"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="EndTime">
                        <el-date-picker @change="getMeetTime" value-format="yyyy-MM-dd" v-model="ruleForm.EndTime" type="date" placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="addSpecial('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!--编辑-->
        <el-dialog title="编辑会议" :visible.sync="editNoticeVisible" @close="cancel('ruleForm1')" width="70%" :close-on-click-modal="false" :append-to-body="true">
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm1" label-width="100px" v-if="editNoticeVisible">
                    <el-form-item label="会议标题" prop="title">
                        <el-input v-model="ruleForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="会议内容" prop="content">
                        <Editor v-model="ruleForm.content" placeholder="请输入内容" />
                    </el-form-item>
                    <el-form-item label="会议说明" prop="Explain">
                        <Editor v-model="ruleForm.Explain" placeholder="请输入说明" />
                    </el-form-item>
                    <el-form-item label="会议类型" prop="meetingType">
                        <el-select placeholder="请选择会议类型" size="small" v-model="ruleForm.meetingType">
                            <el-option v-for="item in selects" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会议地点" prop="address">
                        <el-input v-model="ruleForm.address"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="会议费用" prop="fee" style="width: 30%">
                        <el-input type="number" v-model="ruleForm.fee"></el-input>
                        <span style="color: red;">（单个人费用/元）</span>
                    </el-form-item> -->
                    <el-form-item label="是否展示" prop="isShow">
                        <el-radio-group v-model="ruleForm.isShow">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contact">
                        <el-input v-model="ruleForm.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人电话" prop="phone">
                        <el-input v-model="ruleForm.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="会议封面">
                        <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
                    </el-form-item>
                    <el-form-item label="会议材料">
                        <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUpload" class="apply-file-upload fl"></applyFileUpload>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="StartTime" style="width:340px;">
                        <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期" v-model="ruleForm.StartTime" style="width: 100%;" @change="getMeetTime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="EndTime" style="width:340px;">
                        <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期" v-model="ruleForm.EndTime" style="width: 100%;" @change="getMeetTime"></el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel('ruleForm1')">取 消</el-button>
                <el-button type="primary" @click="editSpecial('ruleForm1')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
import applyFileUpload from "components/uploads/uploadEnclosure.vue";
import { debug } from "util";
import { ContainerMixin, ElementMixin, HandleDirective } from "vue-slicksort";
const SortableList = {
    name: "sortablelist",
    mixins: [ContainerMixin],
    template: `
    <ul class="sortable-list">
      <slot />
    </ul>
  `,
};

const SortableItem = {
    name: "sortableitem",
    mixins: [ElementMixin],
    template: `
    <li class="sortable-list-item">
      <slot />
    </li>
  `,
};

export default {
    data() {
        return {
            dialogVisible: false,
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            addNewNoticeVisible: false,
            editNoticeVisible: false,
            /* -----------添加/修改弹框参数------------ */
            sTitle: "",
            title: "",
            content: "",
            Explain: "",
            newsType: 0,
            downloadUrl: "",
            orderNumber: 0,
            /* --------------------------------------- */
            id: "",
            ids: [],
            noDataShow: false,
            value: "",
            StartTime: "",
            EndTime: "",
            LinkUrl: "",
            address: "",
            contact: "",
            avatorUrl: "",
            phone: "",
            url: "",
            files: [],
            fileIds: [],
            selects: [
                // { label: "1+X培训", value: 0 },
                { label: "师资培训", value: 1 },
                { label: "专业研讨", value: 2 },
                { label: "高层论坛", value: 3 },
                { label: "其它", value: 4 },
            ],
            meetingType: 0,
            urlAliyunOSS: "/api/XOrg/osssign/getsign",
            isShowFileUpload: false,
            ruleForm: {
                title: "",
                content: "",
                Explain: "",
                meetingType: "",
                address: "",
                fee: 100,
                isShow: 1,
                contact: "",
                phone: "",
                StartTime: "",
                EndTime: "",
            },
            rules: {
                title: [{ required: true, message: "请输入会议标题", trigger: "blur" }],
                content: [{ required: true, message: "请输入会议内容", trigger: "blur" }],
                Explain: [{ required: true, message: "请输入会议说明", trigger: "blur" }],
                meetingType: [{ required: true, message: "请选择会议类型", trigger: "change" }],
                address: [{ required: true, message: "请输入会议地点", trigger: "blur" }],
                fee: [{ required: true, message: "请设置会议费用", trigger: "blur" }],
                contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],

                phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],

                StartTime: [
                    {
                        required: true,
                        message: "请输入开始时间",
                        trigger: "change",
                    },
                ],
                EndTime: [
                    {
                        required: true,
                        message: "请输入结束时间",
                        trigger: "change",
                    },
                ],
            },
            meetStartTime: 0,
            meetEndTime: 0,
        };
    },
    components: {
        imageUpload,
        applyFileUpload,
        SortableItem,
        SortableList,
    },
    directives: {
        handle: HandleDirective,
    },
    created() {
        this.getSessionStorage();
        this.school = this.$store.state.auth.userName;
        this.getSpecialList();
    },
    methods: {
        onInput(newList) {
            var courseIds = [];
            for (var i = 0; i < newList.length; i++) {
                courseIds[i] = newList[i].id;
            }
            this.$http
                .post("/api/XOrg/SpecialActivity/updateOrderNum", {
                    activityIds: courseIds,
                })
                .then((rst) => {
                    if (rst.code === 1) {
                        this.$message.success(rst.msg);
                        this.getSpecialList();
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        sort() {
            this.dialogVisible = true;
        },
        getMeetTime() {
            if (this.ruleForm.EndTime != "" && this.ruleForm.StartTime != "") {
                this.meetEndTime = new Date(Date.parse(this.ruleForm.EndTime.replace(/\-/g, "/"))).getTime();
                this.meetStartTime = new Date(Date.parse(this.ruleForm.StartTime.replace(/\-/g, "/"))).getTime();
                if (this.meetStartTime > this.meetEndTime) {
                    this.$message.warning("开始时间应小于结束时间！");
                    return false;
                }
            } else {
                return;
            }
        },
        goRounds(id) {
            this.$router.push({
                name: "PeiXunPlanManager",
                params: { activityId: id },
            });
        },
        onAllFilesUpload(files) {
            this.fileIds = [];
            this.fileIds = files;
        },
        // 开始活动
        startSpecial(id) {
            var that = this;
            this.$http
                .post("/api/XOrg/SpecialActivity/startSpecial", {
                    specialId: id,
                })
                .then((rst) => {
                    if (rst.code === 1) {
                        that.$message.success(rst.msg);
                        that.getSpecialList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //结束活动
        endSpecial(id) {
            var that = this;
            this.$http
                .post("/api/XOrg/SpecialActivity/endSpecial", {
                    specialId: id,
                })
                .then((rst) => {
                    if (rst.code === 1) {
                        that.$message.success(rst.msg);
                        that.getSpecialList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getSpecialList() {
            var that = this;
            this.$http
                .post("/api/XOrg/SpecialActivity/getSpecialList", {
                    title: this.sTitle,
                    type: 1,
                    page: this.pageIndex,
                    pageSize: this.pageSize,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        that.list = rst.list;
                        that.total = rst.pagination.totalCount;
                        that.pageSize = rst.pagination.pageSize;
                        that.pageIndex = rst.pagination.pageIndex;
                        // that.cancel();

                        // 参数存储本地缓存
                        sessionStorage.setItem("wlmeet_MeetingManager_sTitle", that.sTitle);
                        sessionStorage.setItem("wlmeet_MeetingManager_pageIndex", that.pageIndex);
                        sessionStorage.setItem("wlmeet_MeetingManager_pageSize", that.pageSize);
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        // 获取网页缓存信息
        getSessionStorage() {
            // 获取网页缓存信息
            var sTitle = sessionStorage.getItem("wlmeet_MeetingManager_sTitle");
            var pageIndex = Number(sessionStorage.getItem("wlmeet_MeetingManager_pageIndex"));
            var pageSize = Number(sessionStorage.getItem("wlmeet_MeetingManager_pageSize"));

            if (sTitle != null && sTitle != undefined && sTitle != "null" && sTitle != "undefined") {
                this.sTitle = sTitle;
            }
            if (pageIndex != null && pageIndex != undefined) {
                this.pageIndex = pageIndex;
            }
            if (pageSize != null && pageSize != undefined) {
                this.pageSize = pageSize;
            }
        },
        onPageChangeHandler(page) {
            this.pageIndex = page;
            this.getSpecialList(page);
        },
        handleSizeChange(val) {
            this.pageIndex = 1;
            this.pageSize = val;
            this.getSpecialList();
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.Id);
            });
        },
        cancel(formName) {
            this.$refs[formName].resetFields();
            this.addNewNoticeVisible = false;
            this.editNoticeVisible = false;
            this.ruleForm.title = "";
            this.ruleForm.isShow = 1;
            this.ruleForm.content = "";
            this.ruleForm.Explain = "";
            this.ruleForm.StartTime = "";
            this.ruleForm.address = "";
            this.ruleForm.fee = 100;
            this.ruleForm.contact = "";
            this.ruleForm.meetingType = "";
            this.meetingUrl = "";
            this.LinkUrl = "";
            this.fileIds = [];
            this.avatorUrl = "";
            this.files = [];
            this.downloadUrl = "";
            this.ruleForm.EndTime = "";
            this.ruleForm.newsType = 0;
            this.ruleForm.phone = "";
        },
        addSpecial(formName) {
            var that = this;
            if (that.ruleForm.content == "") {
                that.$message.warning("请输入会议内容");
                return false;
            }
            if (that.ruleForm.Explain == "") {
                that.$message.warning("请输入会议说明");
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (that.meetStartTime > that.meetEndTime) {
                        that.$message.warning("开始时间应小于结束时间！");
                        return false;
                    }
                    this.$http
                        .post("/api/XOrg/SpecialActivity/addSpecial", {
                            Title: that.ruleForm.title,
                            Content: that.ruleForm.content,
                            Explain: that.ruleForm.Explain,
                            meetingUrl: that.avatorUrl,
                            type: 1,
                            phone: that.ruleForm.phone,
                            StartTime: that.ruleForm.StartTime,
                            EndTime: that.ruleForm.EndTime,
                            LinkUrl: that.LinkUrl,
                            downloadUrl: that.downloadUrl,
                            address: that.ruleForm.address,
                            fee: that.ruleForm.fee,
                            isShow: that.ruleForm.isShow,
                            contact: that.ruleForm.contact,
                            meetingType: that.ruleForm.meetingType,
                            fileIds: that.fileIds,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message({
                                    showClose: true,
                                    message: rst.msg,
                                    type: "success",
                                });
                                that.getSpecialList();
                            } else {
                                that.$message.warning(rst.msg);
                            }
                            that.cancel(formName);
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        editSpecial(formName) {
            var that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (that.meetStartTime > that.meetEndTime) {
                        that.$message.warning("开始时间应小于结束时间！");
                        return false;
                    }
                    this.$http
                        .post("/api/XOrg/SpecialActivity/editSpecial", {
                            id: that.schoolnewsId,
                            title: that.ruleForm.title,
                            content: that.ruleForm.content,
                            explain: that.ruleForm.Explain,
                            startTime: that.ruleForm.StartTime,
                            endTime: that.ruleForm.EndTime,
                            linkUrl: that.LinkUrl,
                            phone: that.ruleForm.phone,
                            meetingUrl: that.avatorUrl,
                            downloadUrl: that.downloadUrl,
                            address: that.ruleForm.address,
                            fee: that.ruleForm.fee,
                            isShow: that.ruleForm.isShow,
                            contact: that.ruleForm.contact,
                            meetingType: that.ruleForm.meetingType,
                            fileIds: that.fileIds,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message({
                                    message: rst.msg,
                                    type: "success",
                                });
                                that.editNoticeVisible = false;
                                that.getSpecialList();
                                that.cancel(formName);
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        add() {
            this.addNewNoticeVisible = true;
        },
        edit(row) {
            this.editNoticeVisible = true;
            let fileListNew = [];
            this.ruleForm.title = row.title;
            this.ruleForm.content = row.content;
            this.ruleForm.Explain = row.explain;
            this.ruleForm.StartTime = row.startTime;
            this.ruleForm.EndTime = row.endTime;
            this.LinkUrl = row.linkUrl;
            this.schoolnewsId = row.id;
            this.newsType = row.type;
            this.downloadUrl = row.downloadUrl;
            this.ruleForm.address = row.address;
            this.ruleForm.fee = row.fee;
            this.ruleForm.isShow = row.isShow;
            this.ruleForm.contact = row.contact;
            this.avatorUrl = row.meetingUrl;
            this.ruleForm.meetingType = row.meetingType;
            this.ruleForm.phone = row.phone;
            
            row.files.forEach((val) => {
                fileListNew.push({
                    docId: val.Id,
                    name: val.DocTitle,
                    url: val.DocUrl,
                });
            });
            this.files = fileListNew;
            this.editNoticeVisible = true;
        },
        deleteMajor(id) {
            var that = this;
            this.$confirm("此操作将删除该会议, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .post("/api/XOrg/SpecialActivity/deleteSpecial", {
                            id: id,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message({
                                    message: rst.msg,
                                    type: "success",
                                });
                                that.pageIndex = 1;
                                that.getSpecialList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        search() {
            this.pageIndex = 1;
            this.getSpecialList();
        },
        gOView(id) {
            this.$router.push({
                name: "MeetingEnrollManager",
                params: { activityId: id },
            });
        },
        gOHotel(id) {
            this.$router.push({ name: "HotelManager", params: { activityId: id } });
        },
    },
};
</script>

<style lang="scss">
.wlx-meeting-manager-wrapper {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
